export default "__VITE_ASSET__CakQCFB3__"